const BannerAboutus = () => {
  return (
    <section className="bg-primary-light2 py-24">
      <div className="mx-auto max-w-screen-2xl px-4 py-4 lg:flex lg:items-center bg-primary-light">
        <div className=" max-w-full text-center">
          <h1 className="text-xl font-extrabold sm:text-5xl text-black">
            State-of-the-act facilities
            <br />
            for increased productivity.
          </h1>
        </div>
      </div>
    </section>
  );
};

export default BannerAboutus;
